import Icon from "../../../../../assets/favicon-32x32.png";
import {Avatar} from "@mui/material";
import React from "react";

export default function () {
    return <Avatar sx={{ m: 1, bgcolor: '#010101' }}>
    <img src={Icon}/>
</Avatar>}
